import * as yup from "yup";

const schema = yup
  .object({
    userName: yup
      .string()
      .required("User name is required")
      .min(3, "User name must be at least 3 characters")
      .max(50, "User name must not exceed 50 characters"),
    userLocation: yup
      .string()
      .required("Location is required")
      .min(5, "Location must be at least 5 characters")
      .max(100, "Location must not exceed 100 characters"),
    phoneNumber: yup
      .string()
      .required("Phone number is required")
      .matches(/^[0-9]{11}$/, "Phone number must be 11 digits")
  })
  .required();

export default schema;
